import { render, staticRenderFns } from "./PurchasePricing.vue?vue&type=template&id=463061b0&scoped=true"
import script from "./PurchasePricing.vue?vue&type=script&lang=js"
export * from "./PurchasePricing.vue?vue&type=script&lang=js"
import style0 from "./PurchasePricing.vue?vue&type=style&index=0&id=463061b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463061b0",
  null
  
)

export default component.exports